<template>
  <div
    class="vh-100 d-flex flex-column justify-content-center align-items-center"
    background
  >
    <div class="p-4 bg-white rounded-3 position-relative">
      <div class="p-5 position-absolute bottom-100" logo>
        <img
          src="https://cdn.futurerent.co.za/media/futurerent-logo-white.svg"
          alt="FutureRent Logo"
        />
      </div>
      <CredentialLoginComp v-if="emailform" />
      <PinLoginComp v-else />
    </div>
  </div>
</template>

<script>
import CredentialLoginComp from "@/components/login/CredentialLoginComp.vue";
import PinLoginComp from "@/components/login/PinLoginComp.vue";

export default {
  name: "LoginView",
  components: {
    CredentialLoginComp,
    PinLoginComp,
  },
  computed: {
    emailform() {
      return this.$store.state.login.formtype === "emailform";
    },
  },
};
</script>

<style scoped>
[background] {
  background-color: var(--futurerent);
}
[form_label] {
  font-size: 14px;
}
</style>
